import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  CheckCircle2,
  ClipboardList,
  Clock3,
  Phone,
  CalendarDays,
  Wallet,
  LifeBuoy,
  Mail,
  Home,
  BarChart3
} from 'lucide-react';
import './BookingSuccess.css';

const BookingSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const bookingId = location.state?.bookingId || 'N/A';

  const handleGoHome = () => {
    navigate('/');
  };

  const handleTrackBooking = () => {
    navigate('/my-bookings');
  };

  return (
    <div className="success-page">
      <div className="success-container">
        <div className="success-card">

          {/* Success Header */}
          <div className="success-header">
            <div className="success-icon">
              <div className="checkmark">
                <svg viewBox="0 0 24 24" fill="none">
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    fill="#2F6F45"
                  />
                  <path
                    d="M9 12l2 2 4-4"
                    stroke="#FFFFFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>

            <h1 className="success-title">Booking Confirmed!</h1>

            <p className="success-subtitle">
              Your scrap pickup is scheduled
            </p>

            <p className="success-message">
              Great! Your scrap collection has been successfully booked.
              Our team will contact you within 2 hours to confirm the details.
            </p>
          </div>

          {/* Booking Details */}
          <div className="booking-details">
            <h3>
              <ClipboardList
                size={21}
                color="#2F6F45"
                strokeWidth={2.2}
              />
              Booking Details
            </h3>

            <div className="details-grid">
              <div className="detail-item">
                <span className="detail-label">
                  <ClipboardList
                    size={16}
                    color="#2F6F45"
                    strokeWidth={2}
                  />
                  Booking ID
                </span>

                <span className="detail-value">
                  {bookingId}
                </span>
              </div>

              <div className="detail-item">
                <span className="detail-label">
                  <Clock3
                    size={16}
                    color="#2F6F45"
                    strokeWidth={2}
                  />
                  Status
                </span>

                <span className="status-badge">
                  Pending Confirmation
                </span>
              </div>
            </div>
          </div>

          {/* Process Steps */}
          <div className="process-steps">
            <h3>
              <CheckCircle2
                size={22}
                color="#2F6F45"
                strokeWidth={2.2}
              />
              What happens next?
            </h3>

            <div className="steps">

              <div className="step">
                <div className="step-icon">
                  <Phone size={23} strokeWidth={2.2} />
                </div>

                <div className="step-content">
                  <h4>Confirmation Call</h4>

                  <p>
                    Our team will call you within 2 hours to confirm your
                    booking details.
                  </p>

                  <span className="step-time">
                    Within 2 hours
                  </span>
                </div>
              </div>

              <div className="step">
                <div className="step-icon">
                  <CalendarDays size={23} strokeWidth={2.2} />
                </div>

                <div className="step-content">
                  <h4>Pickup Schedule</h4>

                  <p>
                    We'll schedule the pickup at your preferred time and date.
                  </p>

                  <span className="step-time">
                    Same day or next day
                  </span>
                </div>
              </div>

              <div className="step">
                <div className="step-icon">
                  <Wallet size={23} strokeWidth={2.2} />
                </div>

                <div className="step-content">
                  <h4>Collection & Payment</h4>

                  <p>
                    Our collector will visit, weigh your scrap, and make
                    instant payment.
                  </p>

                  <span className="step-time">
                    Instant payment
                  </span>
                </div>
              </div>

            </div>
          </div>

          {/* Support Section */}
          <div className="support-section">
            <h3>
              <LifeBuoy
                size={21}
                color="#2F6F45"
                strokeWidth={2.2}
              />
              Need Help?
            </h3>

            <p>
              Our support team is here to assist you
            </p>

            <div className="support-contacts">

              <div className="contact-item">
                <span className="contact-icon">
                  <Phone
                    size={19}
                    color="#2F6F45"
                    strokeWidth={2.2}
                  />
                </span>

                <div>
                  <strong>Call Us</strong>
                  <span>7278000038</span>
                </div>
              </div>

              <div className="contact-item">
                <span className="contact-icon">
                  <Mail
                    size={19}
                    color="#2F6F45"
                    strokeWidth={2.2}
                  />
                </span>

                <div>
                  <strong>Email Us</strong>
                  <span>
                    scrapsectorbusiness@gmail.com
                  </span>
                </div>
              </div>

            </div>
          </div>

          {/* Action Buttons */}
          <div className="action-buttons">

            <button
              className="btn btn-secondary"
              onClick={handleGoHome}
            >
              <Home size={18} strokeWidth={2.2} />
              Back to Home
            </button>

            <button
              className="btn btn-primary"
              onClick={handleTrackBooking}
            >
              <BarChart3 size={18} strokeWidth={2.2} />
              Track My Booking
            </button>

          </div>

        </div>
      </div>
    </div>
  );
};

export default BookingSuccess;